const FETCH_OPT_INS = "opt-ins/fetch-opt-ins";
const FETCH_OPT_INS_SUCCESS = "opt-ins/fetch-opt-ins-success";
const FETCH_OPT_INS_FAILED = "opt-ins/fetch-opt-ins-failed";
const TOGGLE_OPT_INS = "opt-ins/toggle-opt-ins";
const UPDATE_OPT_INS = "opt-ins/update-opt-ins";
const UPDATE_OPT_INS_SUCCESS = "opt-ins/update-opt-ins-success";
const UPDATE_OPT_INS_FAILED = "opt-ins/update-opt-ins-failed";
const toggleOptIns = (payload) => ({
  type: TOGGLE_OPT_INS,
  payload
});
const fetchOptIns = () => ({
  type: FETCH_OPT_INS
});
const fetchOptInsSuccess = (payload) => ({
  type: FETCH_OPT_INS_SUCCESS,
  payload
});
const fetchOptInsFailed = (error) => ({
  type: FETCH_OPT_INS_FAILED,
  error
});
const updateOptIns = (payload) => ({
  type: UPDATE_OPT_INS,
  payload
});
const updateOptInsSuccess = () => ({
  type: UPDATE_OPT_INS_SUCCESS
});
const updateOptInsFailed = (error) => ({
  type: UPDATE_OPT_INS_FAILED,
  error
});
export {
  FETCH_OPT_INS,
  FETCH_OPT_INS_FAILED,
  FETCH_OPT_INS_SUCCESS,
  TOGGLE_OPT_INS,
  UPDATE_OPT_INS,
  UPDATE_OPT_INS_FAILED,
  UPDATE_OPT_INS_SUCCESS,
  fetchOptIns,
  fetchOptInsFailed,
  fetchOptInsSuccess,
  toggleOptIns,
  updateOptIns,
  updateOptInsFailed,
  updateOptInsSuccess
};
//# sourceMappingURL=actions.js.map
